import { useEffect, useState } from 'react'
import { ColumnDef, DataGridRowProps } from '../types'
import { DataGridCell, DataGridButtonCell, DataGridSelectCell, DataGirdNonEditableCell } from '.'

function DataGridRow <TData> ( props: DataGridRowProps<TData> ) {
    const {
        columnDefs, idx: rowIdx, rowData, noRowNo, data,
        setRowData,
    } = props

    useEffect( () => {
        rowData[ rowIdx ] = data
        setRowData( [ ...rowData ] )
    }, [ data ] )

    useEffect( () => {
        rowData[ rowIdx ] = data
        setRowData( [ ...rowData ] )
    }, [ rowData ] )

    const getDataGridCellComponentByType = (
        columnDef: ColumnDef, idx: number
    ): JSX.Element => {
        const {
            field, width = 50, textAlign, type, editable = true,
            selectProps, buttonProps,
        } = columnDef

        if ( !editable ) return (
            <DataGirdNonEditableCell
                key={ `${ field }${ idx }` }
                field={ field }
                idx={ rowIdx }
                width={ width }
                rowData={ rowData }
                data={ data }
                isRowNum={ field === 'rowNo' }
            />
        )

        if ( type === 'button' ) return (
            <DataGridButtonCell
                key={ `${ field }${ idx }` }
                data={ data }
                width={ width }
                buttonProps={ buttonProps }
            />
        )
        if ( type === 'select' ) return (
            <DataGridSelectCell
                idx={ rowIdx }
                key={ `${ field }${ idx }` }
                field={ field }
                width={ width }
                selectProps={ selectProps }
                rowData={ rowData }
                data={ data }
                setRowData={ setRowData }
            />
        )

        return <DataGridCell
            idx={ rowIdx }
            key={ `${ field }${ idx }` }
            field={ field }
            width={ width }
            textAlign={ textAlign }
            type={ type }
            rowData={ rowData }
            data={ data }
            setRowData={ setRowData }
        />
    }

    return (
        <div className="data-grid-body-row flex" key={`${ rowIdx }${ data }`}>
            {
                columnDefs
                    .reduce( ( acc, colDef, idx ) => {
                        const { field } = colDef
                        idx === 0 && !noRowNo && acc.push( getDataGridCellComponentByType( { field: 'rowNo', editable: false }, idx ) )
                        field && acc.push( getDataGridCellComponentByType( colDef, idx ) )

                        return acc
                    }, [] )
            }
        </div>
    )
}

export default DataGridRow